import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError, } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnvironmentConfiguration } from '../environment/services/environment.configuration';
var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
var httpOptions;
if (isIEOrEdge) {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
    })
  };
} else {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('Ebom_accessToken'),
      'x-api-key':localStorage.getItem('Filename')
    })
  };
}
@Injectable({
  providedIn: 'root'
})
export class FamilyProjectNamcService {

  searchdropdown2UrlApi = this.environment.Mastersearchdropdown2apiUrl;
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  namc = 'getNamcFpn/{proxy+}'
  family = '/getFamilyByNamcFpn/{proxy+}'
  hikiateStatus = 'getHikiateStatusFpn/{proxy+}'
  project = '/getProjectByFamilyFpn/{proxy+}'
  modelYear = '/getModelYearByProjectFpn/{proxy+}'
  modelChangeType = 'getModelChangeTypeFpn/{proxy+}'
  gridData = '/getFamProjAndNamcGrid/{proxy+}'


  constructor(private http: HttpClient, private environment: EnvironmentConfiguration) { }

  //namc
  getNamcFpn(): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = `${this.searchdropdown2UrlApi}/${this.namc}`+'?screenNo=NBPC_9120'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)

      )
  }

  //family
  getFamilyFpn(namcId): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let famParams = new HttpParams().set('namcId', namcId)
    let API_URL = this.environment.Mastersearchdropdown2apiUrl + this.family + "?namcId=" + namcId+'&screenNo=NBPC_9120'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)

      )
  }


  //project
  getProjectFpn(namcId, famCd): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let projectParams = new HttpParams().set('namcId', namcId)
    //                                   .append('famCd', famCd);
    let API_URL = this.environment.Mastersearchdropdown2apiUrl + this.project + "?namcId=" + namcId + '&famCd=' + famCd+'&screenNo=NBPC_9120'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)

      )
  }


  //hikiateStatus
  getHikiateStatusFpn(): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = `${this.searchdropdown2UrlApi}/${this.hikiateStatus}`+'?screenNo=NBPC_9120'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)

      )
  }
  //modelChangeType
  getModelChangeTypefpn(): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = `${this.searchdropdown2UrlApi}/${this.modelChangeType}`+'?screenNo=NBPC_9120'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)

      )
  }
  //modelYear
  getModelYearFpn(namcId, famCd, projCd): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let modelYear = new HttpParams().set('namcId', namcId)
    // .append('famCd', famCd)
    // .append('projCd', projCd);
    let API_URL = this.environment.Mastersearchdropdown2apiUrl + this.modelYear + "?namcId=" + namcId + '&famCd=' + famCd + '&projCd=' + projCd+'&screenNo=NBPC_9120'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)

      )
  }
  //grid data
  getFamilyProjNamcGrid(gridData): Observable<any> {
   var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let gridParams = new HttpParams().set('famCd', gridData.fam)
    //   .append('projCd', gridData.project)
    //   .append('mdlYr', gridData.modelYear)
    //   .append('namcLglEntityId', gridData.namc)
    //   .append('prodStrtDt', gridData.prodDateIn)
    //   .append('prodEndDt', gridData.prodDateOut)
    //   .append('rmrkTxt', gridData.comments)
    //   .append('hikiateStatCombCd', gridData.hikiate)
    //   .append('projChgTypCd', gridData.modelChangeType)
    //   .append('effDt', gridData.effectiveDateIn)
    //   .append('exprDt', gridData.effectiveDateOut)
    //   .append('option', gridData.option)
    let API_URL = this.environment.MastergridapiUrl + this.gridData + '?famCd=' + gridData.fam + '&projCd=' + gridData.project
      + '&mdlYr=' + gridData.modelYear + '&namcLglEntityId=' + gridData.namc + '&prodStrtDt=' + gridData.prodDateIn + '&prodEndDt=' + gridData.prodDateOut
      + '&rmrkTxt=' + gridData.comments + '&hikiateStatCombCd=' + gridData.hikiate + '&projChgTypCd=' + gridData.modelChangeType + '&effDt=' + gridData.effectiveDateIn
      + '&exprDt=' + gridData.effectiveDateOut + '&option=' + gridData.option +'&screenNo=NBPC_9120'+'&fileName=' +fileName;
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)
      )
  }

  // Handle Errors 
  error(error: HttpErrorResponse) {
    let errorMessage:any = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = error.status;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }
}
